import React, { useRef, useEffect, useState } from 'react';
import { InputAdornment, Typography, Container, Grid, Box, Card, CardContent } from "@mui/material";
import { FormControl, TextField } from "@mui/material";
import { Paper, TableContainer, Table, TableHead, TableBody, TableRow, TablePagination } from "@mui/material";
import { Tabs, Tab } from '@mui/material';
import { styled } from '@mui/material/styles';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import { useNavigate } from 'react-router-dom';
import { AntTabs, AntTab, StyledTableCell, StyledTableRow } from '../tabs_style';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';

export default function TasasPorAnoLeyAnterior({ nombre, apellido, modulo }) {
    const [tabIndex, setTabIndex] = React.useState(2);
    const navigate = useNavigate();
    const [containerWidth, setContainerWidth] = useState(0);
    const containerRef = useRef(null);

    useEffect(() => {
        // Actualizar el ancho del contenedor al montar y al cambiar el tamaño de la ventana
        updateContainerWidth();
        window.addEventListener('resize', updateContainerWidth);
        return () => {
            window.removeEventListener('resize', updateContainerWidth);
        };
    }, []);

    const updateContainerWidth = () => {
        if (containerRef.current) {
            const width = containerRef.current.clientWidth;
            setContainerWidth(width);
        }
    };

    const handleChange = (event, newValue) => {
        setTabIndex(newValue);
    };

    const handleChangePageTasa = (event, newPage) => {
        setPageTasa(newPage);
    };

    const handleChangeRowsPerPageTasa = (event) => {
        setRowsPerPageTasa(parseInt(event.target.value, 10));
        setPageTasa(0);
    };

    const [pageTasa, setPageTasa] = useState(0);
    const [rowsPerPageTasa, setRowsPerPageTasa] = useState(5);

    const rowsTasa = [
        { fecha: '', cotizacion: '', year: '', mes: '', factor: '', valor: '' },
    ];

    const currentYear = new Date().getFullYear();

    return (
        <>
            <Grid container direction="column" alignItems="center">
                <Container>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <h2>Tasas Por Año</h2>
                    </div>
                </Container>
                <Container>
                    <Box sx={{ position: 'sticky', top: 0, zIndex: 1, display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                        <Paper square>
                            <AntTabs
                                value={tabIndex}
                                onChange={handleChange}
                                indicatorColor="primary"
                                textColor="primary"
                                variant="scrollable"
                                scrollButtons="auto"
                                TabIndicatorProps={{
                                    style: { display: 'none' }, // O también puedes usar display: 'none' aquí
                                }}
                            >
                                <AntTab label="Resumen" />
                                <AntTab label="Tabla De Interés" />
                                <AntTab label="Tasas Por Año" />
                                <AntTab label="Monto Del Beneficio" />
                                <AntTab label="Datos" />
                                <AntTab label="Cálculos" />
                                <AntTab label="Rebajas" />
                                <AntTab label="Períodos" />
                                <AntTab label="Comparativa Devolución 10%" />
                                <AntTab label="Con Reingreso" />
                            </AntTabs>
                        </Paper>
                    </Box>

                    <Box mt={3}>
                        {/* Contenido de la pestaña actual */}
                        {tabIndex === 0 && navigate('/Separaciones/ResumenLeyAnterior')}
                        {tabIndex === 1 && navigate('/Separaciones/TablaDeInteresLeyAnterior')}
                        {tabIndex === 2}
                        {tabIndex === 3 && navigate('/Separaciones/MontoDelBeneficioLeyAnterior')}
                        {tabIndex === 4 && navigate('/Separaciones/LeyAnterior')}
                        {tabIndex === 5 && navigate('/Separaciones/CalculosLeyAnterior')}
                        {tabIndex === 6 && navigate('/Separaciones/RebajasLeyAnterior')}
                        {tabIndex === 7 && navigate('/Separaciones/PeriodosLeyAnterior')}
                        {tabIndex === 8 && navigate('/Separaciones/ComparativaLeyAnterior')}
                        {tabIndex === 9 && navigate('/Separaciones/ConReingresoLeyAnterior')}

                    </Box>
                </Container>
            </Grid>

            <Box boxShadow={2}>
                <Card variant='outlined'>
                    <CardContent>
                        <Grid container spacing={2} marginTop={2} ref={containerRef}>
                            <Grid item xs={12} sm={6} md={3} lg={3.38}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="nombre"
                                        label="Nombre Participante"
                                        variant="outlined"
                                        inputProps={{ readOnly: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={1.38}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="cotizante"
                                        label="Cotizante"
                                        variant="outlined"
                                        inputProps={{ readOnly: true }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={2.38}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="fechabeneficio"
                                        label="Fecha de Solicitud del Beneficio"
                                        variant="outlined"
                                        inputProps={{ readOnly: true }}
                                        InputProps={{
                                            endAdornment: (
                                                <InputAdornment position="end">
                                                    <CalendarMonthIcon />
                                                </InputAdornment>
                                            ),
                                        }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={2.38}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="valornominal"
                                        label="Valor Nominal de las Cotizaciones"
                                        variant="outlined"
                                        InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                    />
                                </FormControl>
                            </Grid>
                            <Grid item xs={12} sm={6} md={3} lg={2.38}>
                                <FormControl fullWidth>
                                    <TextField
                                        id="valoractual"
                                        label="Valor Actual de las Cotizaciones"
                                        variant="outlined"
                                        InputProps={{ readOnly: true, startAdornment: <InputAdornment position="start">L.</InputAdornment> }}
                                    />
                                </FormControl>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </Box>

            <Box marginTop={3}>
                <TableContainer component={Paper} style={{ maxWidth: `${containerWidth}px`, overflowX: 'auto' }}>
                    {/* Tabla 3 */}
                    <Table>
                        <TableHead>
                            <StyledTableRow>
                                <StyledTableCell style={{ textAlign: 'center', whiteSpace: 'normal' }}><strong>Fecha (dd/mm/aa)</strong></StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}><strong>Cotización (Lps)</strong></StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}><strong>Año</strong></StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}><strong>Mes</strong></StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}><strong>Factor de Actualización</strong></StyledTableCell>
                                <StyledTableCell style={{ textAlign: 'center' }}><strong>Valor Actualizado</strong></StyledTableCell>
                                {[...Array(currentYear - 1970)].map((_, index) => (
                                    <StyledTableCell key={index} style={{ textAlign: 'center' }}><strong>{1971 + index}</strong></StyledTableCell>
                                ))}
                            </StyledTableRow>

                        </TableHead>
                        <TableBody>
                            {(rowsPerPageTasa > 0
                                ? rowsTasa.slice(pageTasa * rowsPerPageTasa, pageTasa * rowsPerPageTasa + rowsPerPageTasa)
                                : rowsTasa
                            ).map((row) => (
                                <StyledTableRow key={row.year}>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{row.fecha}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{row.cotizacion}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{row.year}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{row.mes}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{row.factor}</StyledTableCell>
                                    <StyledTableCell style={{ textAlign: 'center' }}>{row.valor}</StyledTableCell>
                                </StyledTableRow>
                            ))}
                        </TableBody>
                    </Table>
                </TableContainer>
                <TablePagination
                    rowsPerPageOptions={[5, 8]}
                    component="div"
                    count={rowsTasa.length}
                    rowsPerPage={rowsPerPageTasa}
                    page={pageTasa}
                    onPageChange={handleChangePageTasa}
                    onRowsPerPageChange={handleChangeRowsPerPageTasa}
                />
            </Box>
        </>
    );
}
